import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';
import { DOCUMENTS_LIST_COLUMNS } from '../../Documents/DocumentsListGrid.types';
import { FileTypeIcon } from '../../StaticComponents/FileTypeIcon';
import { mapUploadedFileType } from '../../../store/files/upload/upload.helpers';
import React from 'react';
import {
  DocumentStatus,
  ValidationErrorCode,
} from '../../../store/files/documents/documents.list.types';
import { DisplayItemName } from '../../DocumentsAndClauses/ItemName/DisplayItemName';
import { PendingStatus } from './PendingStatus';
import { CLAUSES_LIST_COLUMNS } from '../../Clauses/ClausesListGrid.types';
import {
  getDuplicatedClauseId,
  mapErrorResponseToErrorMessageDetails,
} from '../../../store/files/documents/documents.update.error.helpers';
import { openNewClauseViewModal } from '../../Documents/DocumentViewModal/DocumentRelatedClauses/ClauseRelatedDocuments.hooks';
import { UploadedFileDeleteButton } from '../../UploadFiles/UploadedFileDelete/UploadedFileDeleteButton';
import { UPLOADED_FILE_TYPE } from '../../UploadFiles/UploadedFileDelete/UploadedFileDeleteButton.types';
import { ClauseResponse } from '../../../store/files/clauses/clauses.list.types';

export const COLUMNS_DEFINITION = (type: 'document' | 'clause'): (() => GridColDef[]) => {
  const LIST_COLUMNS = type === 'document' ? DOCUMENTS_LIST_COLUMNS : CLAUSES_LIST_COLUMNS;

  return () => [
    {
      flex: 20,
      headerName: 'File name',
      field:
        type === 'document' ? DOCUMENTS_LIST_COLUMNS.FILE_NAME : CLAUSES_LIST_COLUMNS.CLAUSE_NAME,
      renderCell: ({ row }: GridRenderCellParams) => {
        return (
          <>
            <FileTypeIcon fileType={mapUploadedFileType(row.FileName)} />
            <DisplayItemName item={row} />
          </>
        );
      },
    },
    {
      flex: 10,
      field: LIST_COLUMNS.STATUS,
      renderCell: ({ row }: GridRenderCellParams) => {
        switch (row.Status) {
          case DocumentStatus.PROCESSING:
            return <PendingStatus mode='uploading' label='Processing in progress' />;
          case DocumentStatus.FAILED:
          case DocumentStatus.DUPLICATE:
            switch (row.FailureReason?.errorCode) {
              case ValidationErrorCode.ClauseDuplicateMetadataExtended:
                return <PendingStatus mode='warning' label='Extended' />;
              case ValidationErrorCode.ProductionDuplicateDraftClause:
                return <PendingStatus mode='warning' label='Production duplicate' />;
              default:
                return <PendingStatus mode='error' label='Failed' />;
            }
        }
      },
    },
    {
      flex: 20,
      field: LIST_COLUMNS.FAILURE_REASON,
      cellClassName: 'failure-reason-column',
      renderCell: ({ row }: GridRenderCellParams) => {
        if (row.FailureReason) {
          const ClauseId = getDuplicatedClauseId(row.FailureReason.errorDetails);
          const details = mapErrorResponseToErrorMessageDetails([row.FailureReason]);
          return (
            <div
              className={ClauseId && 'clickable'}
              onClick={() => ClauseId && openNewClauseViewModal({ ClauseId } as ClauseResponse)}
            >
              {details}
            </div>
          );
        }
      },
    },
    {
      field: 'action',
      headerName: '',
      flex: 1,
      sortable: false,
      renderCell: function ButtonCell({ row }: GridRenderCellParams) {
        if (row.Status === DocumentStatus.FAILED || row.Status === DocumentStatus.DUPLICATE) {
          return (
            <UploadedFileDeleteButton
              FileId={type === 'clause' ? row.ClauseId : row.DocumentId}
              type={
                type === 'clause'
                  ? UPLOADED_FILE_TYPE.PENDING_CLAUSE
                  : UPLOADED_FILE_TYPE.PENDING_DOC
              }
            />
          );
        }
      },
    },
  ];
};
